import type { LeaseActionProps } from '../../../models/Types';

const FinishSigningExperience = ({ terminateActiveAction }: LeaseActionProps) => {
  terminateActiveAction();
  return null;
};

export default FinishSigningExperience;
